import axios from 'axios';
import { constants } from 'utils';

const Language = {
  getSupportLanguage: () => axios.get(`${constants.API}/language`)
};

export default Language;
